export const getSyiSlice = (state) => state.views.syi;
export const selectShortDescription = (state) =>
    getSyiSlice(state).shortDescription.shortDescription;
export const selectItemIdFromDraft = (state) =>
    getSyiSlice(state).draft?.itemId || undefined;
